import { CycleBoundaryDrawable } from 'formwork-planner-lib'
import paper from 'paper/dist/paper-core'
import { CycleSegment } from './CycleSegment'

/**
 * Represents a cycle which is made out of cycle segments and has a cycle number assigned
 */
export class Cycle {
  constructor(public segments: CycleSegment[], public cycleNumber: number) {}

  /**
   * Checks if the current cycle has a shared segment end point with another cycle
   * @param that the other cycle
   */
  public isNeighbourTo(that: Cycle): boolean {
    let result = false
    this.segments.forEach((ownSegment) => {
      that.segments.forEach((otherSegment) => {
        if (
          ownSegment.endPoint === otherSegment.endPoint ||
          ownSegment.startPoint === otherSegment.startPoint ||
          ownSegment.endPoint === otherSegment.startPoint ||
          ownSegment.startPoint === otherSegment.endPoint
        ) {
          result = true
        }
      })
    })
    return result
  }

  /**
   * Checks if cycles are the same due to the segments being the same
   * @param that the other cycle
   */
  public equals(that: Cycle): boolean {
    return this.segments.every((segment) =>
      that.segments.some((otherSegment) => segment.equals(otherSegment))
    )
  }

  /**
   * Checks if any of the cycle's segments contain a cycle boundary as start or end point
   * @param boundary
   */
  public hasBoundary(boundary: CycleBoundaryDrawable): boolean {
    let result = false
    this.segments.forEach((segment) => {
      if (segment.startPoint === boundary || segment.endPoint === boundary) {
        result = true
      }
    })
    return result
  }

  /**
   * Returns true if the cycle is not a default cycle generated without cycle boundaries
   */
  public hasBoundaries(): boolean {
    let result = false
    this.segments.forEach((segment) => {
      if (
        segment.startPoint instanceof CycleBoundaryDrawable ||
        segment.endPoint instanceof CycleBoundaryDrawable
      ) {
        result = true
      }
    })
    return result
  }

  /**
   * Returns true if any of the cycle's segments contains the point
   * @param point the point to check for
   * @param tolerance maximum distance from the middle line of a cycle segment (a simple line between the start and end point)
   */
  public containsPoint(point: paper.Point, tolerance: number): boolean {
    let result = false
    this.segments.forEach((segment) => {
      if (segment.containsPoint(point, tolerance)) {
        result = true
      }
    })
    return result
  }
}
